// src/pages/NotFoundPage.tsx
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-gray-900 dark:text-white bg-vw-bg-light dark:bg-[#000F38] relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 opacity-[0.12] dark:opacity-10">
        <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-vw-blue rounded-full animate-pulse dark:bg-white" />
        <div className="absolute bottom-1/3 right-1/4 w-20 h-20 bg-blue-400 rounded-full animate-bounce dark:bg-white" />
      </div>
      
      {/* Main content */}
      <div className="relative z-10 text-center">
        {/* Project name with animation */}
        <div className="mb-8">
          <h2 className="text-2xl font-light tracking-widest opacity-0 animate-[fadeInUp_0.8s_ease-out_0.2s_forwards]">
            vawena
          </h2>
        </div>
        
        {/* 404 with staggered animation */}
        <h1 className="text-6xl font-bold mb-4 opacity-0 animate-[fadeInScale_1s_ease-out_0.5s_forwards]">
          404
        </h1>
        
        {/* Error message with delayed animation */}
        <p className="text-xl mb-6 opacity-0 animate-[fadeInUp_0.8s_ease-out_0.8s_forwards]">
          Oops! The page you're looking for doesn't exist.
        </p>
        
        {/* Button with final animation */}
        <Link
          to="/"
          className="inline-block px-6 py-3 text-lg font-medium rounded-xl shadow-lg hover:scale-105 transition-all duration-300 opacity-0 animate-[fadeInUp_0.8s_ease-out_1.1s_forwards] border border-white/20 text-white bg-gradient-to-t from-vw-blue-dk to-vw-blue hover:brightness-110 dark:from-white dark:to-white dark:text-gray-900 dark:border-gray-200 dark:hover:brightness-95"
        >
          Go Home
        </Link>
      </div>

      {/* Custom keyframe animations */}
      <style >{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        
        @keyframes bounceIn {
          0% {
            opacity: 0;
            transform: scale(0.3) rotate(0deg);
          }
          50% {
            opacity: 1;
            transform: scale(1.1) rotate(5deg);
          }
          100% {
            opacity: 1;
            transform: scale(1) rotate(0deg);
          }
        }
      `}</style>
    </div>
  );
}